import apiClient from '@/services/api-client';

export default {
	getAll() {
		return apiClient().get('/Campaign/GetAll');
	},
	getMenu() {
		return apiClient().get('/Campaign/GetMenu');
	},
	getCampaign(campaignId) {
		return apiClient().get('/Campaign/GetCampaign', {
			params: {
				campaignId,
			},
		});
	},
	getMediasForCampaignItems(campaignItemsIds) {
		return apiClient().post('/Media/Get', {
			campaignItemId: campaignItemsIds,
		});
	},
	getCampaignDisclaimer(campaignId, loanAmount) {
		const endpoint = '/Campaign/GetCampaignDisclaimer';
		return apiClient()
			.get(endpoint, {
				params: {
					campaignId,
					loanAmount,
				},
			})
			.then(({ data }) => data)
			.catch((e) => {
				console.error('Campaign_Disclaimer_Error: ', e);
			});
	},
};
